import { call, put, takeEvery, all } from 'redux-saga/effects'
import assignedTypes from './assignedTypes'
import * as assignedActions from './assignedActions'
import AssignedOrders from '../../services/OrdersService/AssignedOrders'
import notificationActions from '../notifications/notificationActions'

export function * getAssigned ({ payload }) {
  try {
    const { offset } = payload
    if (offset === 0) {
      yield put(assignedActions.clearAssigend())
    }
    const { data, results } = yield call(AssignedOrders.getAssigned, payload)
    yield put(assignedActions.getAssigendSuccess({ data, results }))
  } catch ({ message }) {
    yield put(assignedActions.getAssigendFailure(message))
  }
}

export function * putAssigned ({ payload, callback }) {
  try {
    yield call(AssignedOrders.updateAssigend, payload)
    if (callback) yield callback()
    yield put(notificationActions.SendToast({ message: 'Successfully updated order', type: 'success' }))
    yield put(assignedActions.putAssignedSuccess(payload))
  } catch ({ message }) {
    yield put(notificationActions.SendToast({ message, type: 'error' }))
    yield put(assignedActions.putAssignedFailre(message))
  }
}

export function * onGetAssigned () {
  yield takeEvery(assignedTypes.GET_ASSIGNED, getAssigned)
}

export function * onPutAssigned () {
  yield takeEvery(assignedTypes.PUT_ASSIGNED_ORDER, putAssigned)
}

export function * assignedOrderSaga () {
  yield all([
    call(onGetAssigned),
    call(onPutAssigned)
  ])
}
